import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { PerfilComponent } from './perfil/perfil.component';
import { BuyFoliosComponent } from './perfil/folios/buy-folios/buy-folios.component';
import { NoCompanyFoundComponent } from './no-company-found/no-company-found.component';
import { NewCompanyComponent } from './new-company/new-company.component';




const routes: Routes = [

  {
    path: 'perfil',
    component: PerfilComponent
  },
  {
    path: 'paquetes',
    component: BuyFoliosComponent
  },
  {
    path: 'nonecompany',
    component: NoCompanyFoundComponent
  },
  {
    path: 'newcompany',
    component: NewCompanyComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CuentasRouting {
}
